import { Link } from "react-router-dom";
import { useAARData } from "../../context/AARDataContext";
import "./ReviewerInbox.css";

function ReviewerInbox() {
  const { projects } = useAARData();
  const pendingProjects = projects.filter(
    (project) => String(project.status || "").toUpperCase() === "UNDER REVIEW"
  );

  return (
    <main className="reviewer-inbox">
      <header className="reviewer-inbox-header">
        <span>REVIEW WORKSPACE</span>
        <h1>Reviewer Inbox</h1>
        <p>Documents waiting for review and approval.</p>
      </header>

      <section className="reviewer-inbox-content">
        <div className="reviewer-inbox-summary">
          <strong>{pendingProjects.length}</strong>
          <span>Documents under review</span>
        </div>

        {pendingProjects.length === 0 ? (
          <div className="reviewer-inbox-empty">
            <h2>Inbox is clear</h2>
            <p>There are no AAR documents waiting for review.</p>
          </div>
        ) : (
          <div className="reviewer-inbox-list">
            {pendingProjects.map((project) => (
              <article className="reviewer-inbox-item" key={project.id}>
                <div>
                  <span>{project.type || "AAR"} • {project.year || ""}</span>
                  <h2>{project.title}</h2>
                  <p>{project.subtitle || "No description provided."}</p>
                </div>
                <Link to={`/aar/${project.id}`}>Review AAR</Link>
              </article>
            ))}
          </div>
        )}
      </section>
    </main>
  );
}

export default ReviewerInbox;
